import { Text, VStack } from '@elkaso-app/web-design';

interface IErpRestaurantCell {
  name: string;
  id: number;
}

export const ErpRestaurantCell: React.FC<IErpRestaurantCell> = ({ name, id }) => (
  <VStack align='start' spacing={1}>
    <Text fontWeight='medium'>{name}</Text>
    <Text fontSize='sm' color='gray.500'>
      ID: {id}
    </Text>
  </VStack>
);
